"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var enhance_1 = require("./enhance");
function inject() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var fn = args.shift();
    if (typeof fn !== 'function') {
        console.warn('[haiku core] Inject expects a function as the first argument');
        return fn;
    }
    if (args.length > 0) {
        enhance_1.default(fn, args);
    }
    else {
        enhance_1.default(fn, null); // If no args here, let 'enhance' try to parse them out
    }
    // Used by Haiku.app
    fn.injectee = true;
    return fn;
}
exports.default = inject;
//# sourceMappingURL=inject.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/reflection/inject.js
// module id = 64
// module chunks = 35783957827783 127651196306611 162898551421021